// --- React
import { useMemo } from 'react';
// --- Redux
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
// --- Actions
import * as allActions from './actions';

/**
 * useUsersActions Hook
 *
 * This hook provides access to the users actions in the Redux store.
 * It binds the action creators to the dispatch function,
 * allowing components to dispatch actions easily.
 *
 * @hook
 * @returns {Object} An object containing the bound action creators.
 **/
export function useUsersActions() {
    const dispatch = useDispatch();

    // Bind all action creators to the dispatch function
    return useMemo(() => bindActionCreators(allActions, dispatch), [dispatch]);
}
